<template>
    <div>
        <!-- Previous Button -->
        <span
            class="
                border border-gray-400
                rounded-tl-3xl rounded-bl-3xl
                px-3
                py-2
                text-sm
            "
        >
            <inertia-link
                v-if="prevUrl"
                :href="prevUrl"
                class="text-secondary hover:text-primary"
            >
                <i class="icon-np-chevron-left"></i>
            </inertia-link>
            <i v-else class="icon-np-chevron-left text-gray-400"></i>
        </span>

        <!-- Other Pages -->
        <span v-for="(link, key) in links" :key="key" :class="getClasses(link)">
            <inertia-link v-if="isObject(link) && link.url" :href="link.url">
                <span>{{ link.label }}</span>
            </inertia-link>
            <span v-else-if="isObject(link)">{{ link.label }}</span>
            <span v-else>{{ link }}</span>
        </span>

        <!-- Next Button -->
        <span
            class="
                border border-gray-400
                rounded-tr-3xl rounded-br-3xl
                px-3
                py-2
                text-sm
            "
        >
            <inertia-link
                v-if="nextUrl"
                :href="nextUrl"
                class="text-secondary hover:text-primary"
            >
                <i class="icon-np-chevron-right"></i>
            </inertia-link>
            <i v-else class="icon-np-chevron-right text-gray-400"></i>
        </span>
    </div>
</template>

<script>
export default {
    data() {
        return {
            prevUrl: null,
            nextUrl: null,
            firstUrl: null,
            lastUrl: null,
            lastPage: null,
            currentPage: null,
            links: [],
        };
    },
    mounted() {
        this.prevUrl = this.vehicles.prev_page_url;
        this.nextUrl = this.vehicles.next_page_url;
        this.firstUrl = this.vehicles.first_page_url;
        this.lastUrl = this.vehicles.last_page_url;
        this.lastPage = this.vehicles.last_page;
        this.currentPage = this.vehicles.current_page;

        if (this.vehicles.links.length <= 6) {
            for (let link of this.vehicles.links) {
                if (!isNaN(link.label)) {
                    this.links.push(link);
                }
            }
        } else if (this.currentPage <= 3) {
            for (let link of this.vehicles.links) {
                if (!isNaN(link.label)) {
                    let label = parseInt(link.label);
                    if (label <= 3) {
                        this.links.push(link);
                    }
                }
            }
            this.links.push("...");
            this.links.push({
                active: false,
                label: this.lastPage.toString(),
                url: this.lastUrl,
            });
        } else if (this.currentPage >= this.lastPage - 2) {
            this.links.push({
                active: false,
                label: "1",
                url: this.firstUrl,
            });
            this.links.push("...");
            for (let link of this.vehicles.links) {
                if (!isNaN(link.label)) {
                    let label = parseInt(link.label);
                    if (label >= this.lastPage - 2) {
                        this.links.push(link);
                    }
                }
            }
        } else {
            this.links.push({
                active: false,
                label: "1",
                url: this.firstUrl,
            });
            this.links.push("...");
            for (let link of this.vehicles.links) {
                if (link.active) {
                    this.links.push(link);
                }
            }
            this.links.push("...");
            this.links.push({
                active: false,
                label: this.lastPage.toString(),
                url: this.lastUrl,
            });
        }
    },
    methods: {
        getClasses(link) {
            let classes = [
                "border-t",
                "border-b",
                "border-gray-400",
                "px-3",
                "py-2",
                "text-sm",
                "hover:text-primary",
            ];

            if (
                this.isObject(link) &&
                parseInt(link.label) === this.currentPage
            ) {
                classes.push("text-primary");
                classes.push("font-medium");
            } else {
                classes.push("text-secondary");
            }

            return classes;
        },
        isObject(value) {
            return typeof value === "object";
        },
    },
    props: {
        vehicles: {
            type: Object,
            required: true,
        },
    },
};
</script>
